import { get, post, put, del } from "../client";
import {
  PARSE_REMINDER,
  REMINDERS_LIST,
  REMINDERS_TRIGGERED,
  REMINDERS_CREATE,
  REMINDERS_UPDATE,
  REMINDERS_COMPLETE,
  REMINDERS_SNOOZE,
  REMINDERS_DELETE,
} from "../routes";

export default {
  parse_reminder: async (data) => await post(PARSE_REMINDER, data),
  get_reminders: async (status = "all") => await get(`${REMINDERS_LIST}?status=${status}`),
  get_triggered: async () => await get(REMINDERS_TRIGGERED),
  create_reminder: async (data) => await post(REMINDERS_CREATE, data),
  update_reminder: async (id, data) => await put(REMINDERS_UPDATE(id), data),
  complete_reminder: async (id) => await put(REMINDERS_COMPLETE(id)),
  snooze_reminder: async (id, data) => await put(REMINDERS_SNOOZE(id), data),
  delete_reminder: async (id) => await del(REMINDERS_DELETE(id)),
};
